// Legal pages content — FR (source of truth), NL, EN.
// Rendered via dangerouslySetInnerHTML, so sections may contain inline HTML.

export const mentionsContent = {
  fr: {
    title: "Mentions légales",
    sections: [
      {
        heading: "1. Éditeur du site",
        html: `Le site <strong>flexi-location.be</strong> est édité par :<br /><br />
          <strong>D.P.F. Partners S.A.</strong><br />
          Forme juridique : Société Anonyme<br />
          Siège social : 304, Chaussée de Stockel, 1200 Bruxelles, Belgique<br />
          Numéro de TVA : BE 0477.795.373<br />
          Email : <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Hébergeur",
        html: `Le site est hébergé par :<br /><br />
          <strong>Combell</strong><br />
          Skaldenstraat 121, 9042 Gent, Belgique<br />
          Site web : <a href="https://www.combell.com" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.combell.com</a>`,
      },
      {
        heading: "3. Propriété intellectuelle",
        html: `L'ensemble du contenu du site flexi-location.be (textes, images, graphismes, logo, icônes, sons, logiciels, etc.) est la propriété exclusive de D.P.F. Partners S.A. ou de ses partenaires et est protégé par les lois belges et internationales relatives à la propriété intellectuelle.
          <br /><br />Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de D.P.F. Partners S.A.`,
      },
      {
        heading: "4. Limitation de responsabilité",
        html: `D.P.F. Partners S.A. s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, D.P.F. Partners S.A. ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
          <br /><br />En conséquence, D.P.F. Partners S.A. décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.`,
      },
      {
        heading: "5. Droit applicable",
        html: `Les présentes mentions légales sont régies par le droit belge. En cas de litige, les tribunaux de Bruxelles seront seuls compétents.`,
      },
    ],
  },
  nl: {
    title: "Wettelijke vermeldingen",
    sections: [
      {
        heading: "1. Uitgever van de site",
        html: `De site <strong>flexi-location.be</strong> wordt uitgegeven door:<br /><br />
          <strong>D.P.F. Partners N.V.</strong><br />
          Rechtsvorm: Naamloze Vennootschap<br />
          Maatschappelijke zetel: Stokkelse Steenweg 304, 1200 Brussel, België<br />
          BTW-nummer: BE 0477.795.373<br />
          E-mail: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Hostingprovider",
        html: `De site wordt gehost door:<br /><br />
          <strong>Combell</strong><br />
          Skaldenstraat 121, 9042 Gent, België<br />
          Website: <a href="https://www.combell.com" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.combell.com</a>`,
      },
      {
        heading: "3. Intellectuele eigendom",
        html: `De volledige inhoud van de site flexi-location.be (teksten, afbeeldingen, graphics, logo, iconen, geluiden, software, enz.) is de exclusieve eigendom van D.P.F. Partners N.V. of haar partners en wordt beschermd door de Belgische en internationale wetten inzake intellectuele eigendom.
          <br /><br />Elke reproductie, weergave, wijziging, publicatie of aanpassing van alle of een deel van de elementen van de site, ongeacht het gebruikte middel of procedé, is verboden behoudens voorafgaande schriftelijke toestemming van D.P.F. Partners N.V.`,
      },
      {
        heading: "4. Beperking van aansprakelijkheid",
        html: `D.P.F. Partners N.V. streeft ernaar de juistheid en actualiteit van de op deze site verspreide informatie zo goed mogelijk te waarborgen. D.P.F. Partners N.V. kan echter de juistheid, nauwkeurigheid of volledigheid van de op deze site beschikbare informatie niet garanderen.
          <br /><br />Bijgevolg wijst D.P.F. Partners N.V. elke aansprakelijkheid af voor onjuistheden, onnauwkeurigheden of weglatingen met betrekking tot de op deze site beschikbare informatie.`,
      },
      {
        heading: "5. Toepasselijk recht",
        html: `Deze wettelijke vermeldingen worden beheerst door het Belgisch recht. In geval van geschil zijn uitsluitend de rechtbanken van Brussel bevoegd.`,
      },
    ],
  },
  en: {
    title: "Legal notice",
    sections: [
      {
        heading: "1. Site publisher",
        html: `The site <strong>flexi-location.be</strong> is published by:<br /><br />
          <strong>D.P.F. Partners S.A.</strong><br />
          Legal form: Public Limited Company (Société Anonyme)<br />
          Registered office: 304, Chaussée de Stockel, 1200 Brussels, Belgium<br />
          VAT number: BE 0477.795.373<br />
          Email: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Hosting provider",
        html: `The site is hosted by:<br /><br />
          <strong>Combell</strong><br />
          Skaldenstraat 121, 9042 Gent, Belgium<br />
          Website: <a href="https://www.combell.com" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.combell.com</a>`,
      },
      {
        heading: "3. Intellectual property",
        html: `All content on the flexi-location.be website (text, images, graphics, logos, icons, sounds, software, etc.) is the exclusive property of D.P.F. Partners S.A. or its partners and is protected by Belgian and international laws on intellectual property.
          <br /><br />Any reproduction, representation, modification, publication or adaptation of all or part of the website's content, by any means or process whatsoever, is prohibited without the prior written consent of D.P.F. Partners S.A.`,
      },
      {
        heading: "4. Limitation of liability",
        html: `D.P.F. Partners S.A. strives to ensure the accuracy and timeliness of the information published on this site. However, D.P.F. Partners S.A. cannot guarantee the accuracy, precision or completeness of the information made available on this site.
          <br /><br />Accordingly, D.P.F. Partners S.A. disclaims all liability for any inaccuracy, imprecision or omission concerning the information available on this site.`,
      },
      {
        heading: "5. Applicable law",
        html: `These legal notices are governed by Belgian law. In the event of a dispute, the courts of Brussels shall have exclusive jurisdiction.`,
      },
    ],
  },
};

export const cgvContent = {
  fr: {
    title: "Conditions générales de vente",
    sections: [
      {
        heading: "Article 1 - Objet",
        html: `Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre <strong>D.P.F. Partners S.A.</strong> (ci-après "le Prestataire"), société anonyme de droit belge, immatriculée sous le numéro de TVA BE 0477.795.373, dont le siège social est situé au 304, Chaussée de Stockel, 1200 Bruxelles, et toute personne physique ou morale (ci-après "le Client") souhaitant procéder à la location d'espaces professionnels via le site flexi-location.be.`,
      },
      {
        heading: "Article 2 - Services proposés",
        html: `Le Prestataire propose la location d'espaces de travail professionnels, comprenant :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Des salles de réunion</li>
            <li>Des espaces de coworking</li>
            <li>Des bureaux privés</li>
            <li>Une grande salle polyvalente</li>
          </ul>
          <p class="mt-2">La réservation peut se faire à l'heure, à la journée ou à la semaine, selon les disponibilités.</p>`,
      },
      {
        heading: "Article 3 - Réservation et paiement",
        html: `Toute réservation est effectuée en ligne via le site flexi-location.be. Le Client sélectionne l'espace souhaité, la date et la durée de la réservation. Le paiement est effectué en ligne par carte bancaire ou Bancontact via la plateforme sécurisée Stripe.
          <br /><br />La réservation est confirmée dès réception du paiement intégral. Un code d'accès unique est alors communiqué au Client par email.`,
      },
      {
        heading: "Article 4 - Tarifs",
        html: `Les tarifs sont indiqués en euros (EUR), toutes taxes comprises (TTC). Le Prestataire se réserve le droit de modifier ses tarifs à tout moment. Les tarifs applicables sont ceux en vigueur au moment de la réservation.
          <br /><br />Les clients bénéficiant d'un abonnement mensuel ou annuel profitent d'une réduction sur les tarifs standard, conformément aux conditions de leur abonnement.`,
      },
      {
        heading: "Article 5 - Abonnements",
        html: `Le Prestataire propose des formules d'abonnement mensuel et annuel offrant des réductions sur les réservations. L'abonnement est payé à l'avance et est valable pour la durée souscrite. L'abonnement n'est pas remboursable en cas de résiliation anticipée par le Client, sauf disposition légale contraire.`,
      },
      {
        heading: "Article 6 - Annulation et remboursement",
        html: `Le Client peut annuler une réservation selon les conditions suivantes :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Sans abonnement :</strong> annulation gratuite jusqu'à 7 jours avant le début de la réservation. Remboursement intégral automatique.</li>
            <li><strong>Abonnement mensuel :</strong> annulation gratuite jusqu'à 48 heures avant le début de la réservation. Remboursement intégral automatique.</li>
            <li><strong>Abonnement annuel :</strong> annulation gratuite jusqu'à 24 heures avant le début de la réservation. Remboursement intégral automatique.</li>
          </ul>
          <p class="mt-2"><strong>Toute annulation hors délai est impossible.</strong> Le Client ne pourra ni annuler ni obtenir de remboursement une fois le délai d'annulation dépassé.</p>
          <p class="mt-2">Le remboursement est effectué automatiquement sur le moyen de paiement utilisé lors de la réservation, dans un délai de 5 à 10 jours ouvrables.</p>`,
      },
      {
        heading: "Article 7 - Accès aux espaces",
        html: `Après confirmation du paiement, un code d'accès unique est communiqué au Client par email. Ce code est strictement personnel et ne peut être transmis à des tiers. Le Client s'engage à respecter les horaires de sa réservation et à laisser l'espace en bon état.`,
      },
      {
        heading: "Article 8 - Responsabilité",
        html: `Le Client est responsable de tout dommage causé aux locaux, aux équipements et au mobilier mis à sa disposition pendant la durée de la réservation. Le Prestataire décline toute responsabilité en cas de vol, perte ou détérioration des effets personnels du Client.
          <br /><br /><strong>Restitution des locaux :</strong> à la fin de chaque réservation, le Client s'engage à rendre les locaux dans l'état initial où il les a trouvés : meubles, chaises et matériel rangés comme à son arrivée, toilettes propres et fonctionnelles, déchets sortis ou déposés dans les poubelles prévues. Lors de la confirmation de paiement, le Client coche explicitement une case marquant son acceptation de cet engagement.
          <br /><br /><strong>Supplément forfaitaire de remise en état :</strong> en cas de désordre, salissure ou rangement non effectué constaté par le Prestataire après la réservation, un supplément forfaitaire de <strong>30 EUR (TTC)</strong> sera facturé automatiquement au Client au titre du nettoyage et de la remise en état. Ce supplément ne couvre pas les dégradations matérielles, qui restent facturées séparément au coût réel.`,
      },
      {
        heading: "Article 9 - Droit de rétractation",
        html: `Conformément à l'article VI.53 du Code de droit économique belge, le droit de rétractation ne s'applique pas aux services de réservation d'hébergement ou de location d'espace lorsque le contrat prévoit une date ou une période d'exécution déterminée.`,
      },
      {
        heading: "Article 10 - Litiges",
        html: `Les présentes CGV sont soumises au droit belge. En cas de litige, les parties s'engagent à rechercher une solution amiable. À défaut, les tribunaux de l'arrondissement judiciaire de Bruxelles seront seuls compétents.`,
      },
      {
        heading: "Article 11 - Contact",
        html: `Pour toute question relative aux présentes CGV, vous pouvez nous contacter à l'adresse : <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a>`,
      },
    ],
  },
  nl: {
    title: "Algemene verkoopvoorwaarden",
    sections: [
      {
        heading: "Artikel 1 - Voorwerp",
        html: `Deze Algemene Verkoopvoorwaarden (AVV) regelen de contractuele betrekkingen tussen <strong>D.P.F. Partners N.V.</strong> (hierna "de Dienstverlener"), een naamloze vennootschap naar Belgisch recht, ingeschreven onder het BTW-nummer BE 0477.795.373, met maatschappelijke zetel te Stokkelse Steenweg 304, 1200 Brussel, en elke natuurlijke of rechtspersoon (hierna "de Klant") die professionele ruimtes wenst te huren via de site flexi-location.be.`,
      },
      {
        heading: "Artikel 2 - Aangeboden diensten",
        html: `De Dienstverlener biedt de verhuur van professionele werkruimtes aan, waaronder:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Vergaderzalen</li>
            <li>Coworking-ruimtes</li>
            <li>Privékantoren</li>
            <li>Een grote polyvalente zaal</li>
          </ul>
          <p class="mt-2">De reservering kan per uur, per dag of per week gebeuren, afhankelijk van de beschikbaarheid.</p>`,
      },
      {
        heading: "Artikel 3 - Reservering en betaling",
        html: `Elke reservering wordt online gedaan via de site flexi-location.be. De Klant selecteert de gewenste ruimte, de datum en de duur van de reservering. De betaling gebeurt online via bankkaart of Bancontact op het beveiligde Stripe-platform.
          <br /><br />De reservering wordt bevestigd zodra de volledige betaling is ontvangen. Een unieke toegangscode wordt dan per e-mail aan de Klant meegedeeld.`,
      },
      {
        heading: "Artikel 4 - Tarieven",
        html: `De tarieven worden aangegeven in euro (EUR), inclusief alle belastingen (BTWI). De Dienstverlener behoudt zich het recht voor om zijn tarieven te allen tijde te wijzigen. De toepasselijke tarieven zijn die welke van kracht zijn op het moment van de reservering.
          <br /><br />Klanten met een maand- of jaarabonnement genieten een korting op de standaardtarieven, overeenkomstig de voorwaarden van hun abonnement.`,
      },
      {
        heading: "Artikel 5 - Abonnementen",
        html: `De Dienstverlener biedt maand- en jaarabonnementen aan die kortingen op reserveringen opleveren. Het abonnement wordt vooraf betaald en is geldig voor de gekozen duur. Het abonnement is niet terugbetaalbaar in geval van vroegtijdige opzegging door de Klant, behoudens andersluidende wettelijke bepaling.`,
      },
      {
        heading: "Artikel 6 - Annulering en terugbetaling",
        html: `De Klant kan een reservering annuleren onder de volgende voorwaarden:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Zonder abonnement:</strong> gratis annulering tot 7 dagen vóór het begin van de reservering. Automatische volledige terugbetaling.</li>
            <li><strong>Maandabonnement:</strong> gratis annulering tot 48 uur vóór het begin van de reservering. Automatische volledige terugbetaling.</li>
            <li><strong>Jaarabonnement:</strong> gratis annulering tot 24 uur vóór het begin van de reservering. Automatische volledige terugbetaling.</li>
          </ul>
          <p class="mt-2"><strong>Elke annulering buiten de termijn is onmogelijk.</strong> De Klant kan noch annuleren noch een terugbetaling krijgen nadat de annuleringstermijn is verstreken.</p>
          <p class="mt-2">De terugbetaling gebeurt automatisch op het betaalmiddel dat bij de reservering werd gebruikt, binnen een termijn van 5 tot 10 werkdagen.</p>`,
      },
      {
        heading: "Artikel 7 - Toegang tot de ruimtes",
        html: `Na bevestiging van de betaling wordt een unieke toegangscode per e-mail aan de Klant meegedeeld. Deze code is strikt persoonlijk en mag niet aan derden worden doorgegeven. De Klant verbindt zich ertoe de uren van zijn reservering te respecteren en de ruimte in goede staat achter te laten.`,
      },
      {
        heading: "Artikel 8 - Aansprakelijkheid",
        html: `De Klant is aansprakelijk voor alle schade die tijdens de duur van de reservering aan de lokalen, uitrusting en meubilair wordt toegebracht. De Dienstverlener wijst elke aansprakelijkheid af in geval van diefstal, verlies of beschadiging van persoonlijke bezittingen van de Klant.
          <br /><br /><strong>Teruggave van de lokalen:</strong> aan het einde van elke reservering verbindt de Klant zich ertoe de lokalen in de oorspronkelijke staat terug te geven waarin hij ze heeft aangetroffen: meubels, stoelen en materiaal opgeruimd zoals bij aankomst, propere en functionele toiletten, afval meegenomen of in de voorziene vuilnisbakken gedeponeerd. Bij de bevestiging van de betaling vinkt de Klant uitdrukkelijk een vakje aan dat zijn aanvaarding van deze verbintenis bevestigt.
          <br /><br /><strong>Forfaitaire toeslag voor herstel:</strong> in geval van wanorde, vuil of niet uitgevoerde opruiming vastgesteld door de Dienstverlener na de reservering, wordt automatisch een forfaitaire toeslag van <strong>30 EUR (BTW inbegrepen)</strong> aan de Klant gefactureerd voor schoonmaak en herstel. Deze toeslag dekt geen materiële schade, die afzonderlijk tegen werkelijke kostprijs wordt aangerekend.`,
      },
      {
        heading: "Artikel 9 - Herroepingsrecht",
        html: `Overeenkomstig artikel VI.53 van het Belgische Wetboek van economisch recht is het herroepingsrecht niet van toepassing op diensten van reservering van logies of verhuur van ruimte wanneer de overeenkomst in een bepaalde datum of uitvoeringsperiode voorziet.`,
      },
      {
        heading: "Artikel 10 - Geschillen",
        html: `Deze AVV zijn onderworpen aan het Belgisch recht. In geval van geschil zullen de partijen trachten een minnelijke oplossing te vinden. Bij gebreke daarvan zijn uitsluitend de rechtbanken van het gerechtelijk arrondissement Brussel bevoegd.`,
      },
      {
        heading: "Artikel 11 - Contact",
        html: `Voor elke vraag met betrekking tot deze AVV kunt u contact met ons opnemen op: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a>`,
      },
    ],
  },
  en: {
    title: "General terms and conditions of sale",
    sections: [
      {
        heading: "Article 1 - Purpose",
        html: `These General Terms and Conditions of Sale (GTCS) govern the contractual relationship between <strong>D.P.F. Partners S.A.</strong> (hereinafter "the Provider"), a public limited company under Belgian law, registered under VAT number BE 0477.795.373, with registered office at 304, Chaussée de Stockel, 1200 Brussels, and any individual or legal entity (hereinafter "the Client") wishing to rent professional spaces via the flexi-location.be website.`,
      },
      {
        heading: "Article 2 - Services offered",
        html: `The Provider offers the rental of professional workspaces, including:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Meeting rooms</li>
            <li>Coworking spaces</li>
            <li>Private offices</li>
            <li>A large multi-purpose room</li>
          </ul>
          <p class="mt-2">Bookings can be made hourly, daily or weekly, subject to availability.</p>`,
      },
      {
        heading: "Article 3 - Booking and payment",
        html: `All bookings are made online via flexi-location.be. The Client selects the desired space, the date and the duration of the booking. Payment is made online by credit card or Bancontact via the secure Stripe platform.
          <br /><br />The booking is confirmed upon receipt of full payment. A unique access code is then sent to the Client by email.`,
      },
      {
        heading: "Article 4 - Pricing",
        html: `Prices are shown in euros (EUR), all taxes included. The Provider reserves the right to change its prices at any time. The prices applicable are those in force at the time of booking.
          <br /><br />Clients with a monthly or annual subscription benefit from a discount on standard rates, in accordance with the terms of their subscription.`,
      },
      {
        heading: "Article 5 - Subscriptions",
        html: `The Provider offers monthly and annual subscription plans providing discounts on bookings. The subscription is paid in advance and is valid for the chosen duration. The subscription is non-refundable in the event of early termination by the Client, unless otherwise provided by law.`,
      },
      {
        heading: "Article 6 - Cancellation and refund",
        html: `The Client may cancel a booking under the following conditions:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Without subscription:</strong> free cancellation up to 7 days before the start of the booking. Automatic full refund.</li>
            <li><strong>Monthly subscription:</strong> free cancellation up to 48 hours before the start of the booking. Automatic full refund.</li>
            <li><strong>Annual subscription:</strong> free cancellation up to 24 hours before the start of the booking. Automatic full refund.</li>
          </ul>
          <p class="mt-2"><strong>Any late cancellation is not possible.</strong> The Client cannot cancel or obtain a refund once the cancellation deadline has passed.</p>
          <p class="mt-2">The refund is automatically made to the payment method used for the booking, within 5 to 10 working days.</p>`,
      },
      {
        heading: "Article 7 - Access to spaces",
        html: `Upon confirmation of payment, a unique access code is sent to the Client by email. This code is strictly personal and may not be shared with third parties. The Client undertakes to respect the booking hours and to leave the space in good condition.`,
      },
      {
        heading: "Article 8 - Liability",
        html: `The Client is liable for any damage caused to the premises, equipment and furniture made available during the booking period. The Provider disclaims all liability for theft, loss or damage to the Client's personal belongings.
          <br /><br /><strong>Return of the premises:</strong> at the end of each booking, the Client undertakes to leave the premises in the original condition in which they were found: furniture, chairs and equipment arranged as on arrival, clean and functional toilets, waste taken away or placed in the bins provided. When confirming payment, the Client explicitly ticks a checkbox confirming acceptance of this commitment.
          <br /><br /><strong>Flat-rate cleaning surcharge:</strong> in the event of disorder, dirt or failure to tidy up observed by the Provider after the booking, a flat-rate surcharge of <strong>EUR 30 (incl. VAT)</strong> will be automatically billed to the Client for cleaning and restoration. This surcharge does not cover material damage, which is invoiced separately at actual cost.`,
      },
      {
        heading: "Article 9 - Right of withdrawal",
        html: `In accordance with article VI.53 of the Belgian Code of Economic Law, the right of withdrawal does not apply to booking services for accommodation or space rental when the contract provides for a specific date or period of performance.`,
      },
      {
        heading: "Article 10 - Disputes",
        html: `These GTCS are subject to Belgian law. In the event of a dispute, the parties undertake to seek an amicable solution. Failing this, the courts of the Brussels judicial district shall have exclusive jurisdiction.`,
      },
      {
        heading: "Article 11 - Contact",
        html: `For any question regarding these GTCS, please contact us at: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a>`,
      },
    ],
  },
};

export const privacyContent = {
  fr: {
    title: "Politique de confidentialité et RGPD",
    sections: [
      {
        heading: "1. Responsable du traitement",
        html: `Le responsable du traitement des données personnelles collectées via le site flexi-location.be est :<br /><br />
          <strong>D.P.F. Partners S.A.</strong><br />
          304, Chaussée de Stockel, 1200 Bruxelles, Belgique<br />
          TVA : BE 0477.795.373<br />
          Email : <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Données collectées",
        html: `Dans le cadre de l'utilisation du site et de ses services, nous sommes amenés à collecter les données personnelles suivantes :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Données d'identification :</strong> nom, prénom, adresse email</li>
            <li><strong>Données de contact :</strong> numéro de téléphone (facultatif)</li>
            <li><strong>Données de réservation :</strong> espaces réservés, dates, heures, montants</li>
            <li><strong>Données de paiement :</strong> traitées de manière sécurisée par Stripe (nous ne stockons pas vos données bancaires)</li>
            <li><strong>Données de connexion :</strong> adresse IP, type de navigateur, pages consultées</li>
          </ul>`,
      },
      {
        heading: "3. Finalités du traitement",
        html: `Les données personnelles sont collectées pour les finalités suivantes :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Gestion des réservations et des paiements</li>
            <li>Envoi des codes d'accès et confirmations par email</li>
            <li>Gestion des abonnements</li>
            <li>Communication relative au service (modifications, annulations)</li>
            <li>Amélioration du service et statistiques d'utilisation</li>
            <li>Respect des obligations légales et comptables</li>
          </ul>`,
      },
      {
        heading: "4. Base légale du traitement",
        html: `Le traitement de vos données repose sur :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>L'exécution du contrat :</strong> le traitement est nécessaire à la gestion de votre réservation et de votre compte</li>
            <li><strong>L'obligation légale :</strong> pour les obligations comptables et fiscales</li>
            <li><strong>L'intérêt légitime :</strong> pour l'amélioration de nos services</li>
            <li><strong>Le consentement :</strong> pour l'envoi de communications commerciales (le cas échéant)</li>
          </ul>`,
      },
      {
        heading: "5. Durée de conservation",
        html: `Les données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Données de compte :</strong> pendant la durée de l'inscription, puis 3 ans après la dernière activité</li>
            <li><strong>Données de réservation :</strong> 10 ans (obligations comptables belges)</li>
            <li><strong>Données de connexion :</strong> 1 an</li>
          </ul>`,
      },
      {
        heading: "6. Destinataires des données",
        html: `Vos données personnelles peuvent être transmises aux destinataires suivants :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Stripe :</strong> pour le traitement sécurisé des paiements</li>
            <li><strong>Resend :</strong> pour l'envoi des emails transactionnels (confirmations, codes d'accès)</li>
            <li><strong>Combell :</strong> hébergeur du site</li>
          </ul>
          <p class="mt-2">Ces sous-traitants sont liés par des obligations contractuelles de confidentialité et de sécurité conformément au RGPD.</p>`,
      },
      {
        heading: "7. Transfert hors UE",
        html: `Certains de nos sous-traitants (Stripe) peuvent traiter des données en dehors de l'Espace Économique Européen. Dans ce cas, des garanties appropriées sont mises en place (clauses contractuelles types de la Commission européenne).`,
      },
      {
        heading: "8. Cookies",
        html: `Le site utilise des cookies pour assurer son bon fonctionnement et, avec votre consentement, pour mesurer l'audience.
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Cookies strictement nécessaires :</strong> session, préférences de langue, sécurité (aucun consentement requis)</li>
            <li><strong>Cookies de mesure d'audience :</strong> uniquement si vous y consentez via notre bandeau</li>
          </ul>
          <p class="mt-2">Vous pouvez à tout moment modifier vos préférences via le lien <strong>"Gérer mes cookies"</strong> en bas de page. Notre bandeau de consentement est propulsé par <strong>Tarteaucitron.js</strong>, une solution open source RGPD (<a href="https://tarteaucitron.io" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">tarteaucitron.io</a>), compatible avec le Google Consent Mode v2.</p>`,
      },
      {
        heading: "9. Vos droits",
        html: `Conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation belge, vous disposez des droits suivants :
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Droit d'accès :</strong> obtenir la confirmation que des données vous concernant sont traitées et en obtenir une copie</li>
            <li><strong>Droit de rectification :</strong> faire corriger des données inexactes ou incomplètes</li>
            <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données dans les conditions prévues par le RGPD</li>
            <li><strong>Droit à la limitation :</strong> demander la limitation du traitement de vos données</li>
            <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré et couramment utilisé</li>
            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données pour des motifs légitimes</li>
          </ul>
          <p class="mt-3">Pour exercer ces droits, contactez-nous à : <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a></p>
          <p class="mt-2">Nous nous engageons à répondre dans un délai d'un mois à compter de la réception de votre demande.</p>`,
      },
      {
        heading: "10. Autorité de contrôle",
        html: `Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d'introduire une réclamation auprès de l'Autorité de protection des données (APD) :
          <p class="mt-2"><strong>Autorité de protection des données</strong><br />
          Rue de la Presse, 35 - 1000 Bruxelles<br />
          <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.autoriteprotectiondonnees.be</a></p>`,
      },
      {
        heading: "11. Modification de la politique",
        html: `D.P.F. Partners S.A. se réserve le droit de modifier la présente politique de confidentialité à tout moment. Les modifications prennent effet dès leur publication sur le site. Nous vous invitons à consulter régulièrement cette page.
          <p class="mt-2 text-[#737373]">Dernière mise à jour : Février 2026</p>`,
      },
    ],
  },
  nl: {
    title: "Privacybeleid en AVG",
    sections: [
      {
        heading: "1. Verwerkingsverantwoordelijke",
        html: `De verwerkingsverantwoordelijke voor de persoonsgegevens die via de site flexi-location.be worden verzameld is:<br /><br />
          <strong>D.P.F. Partners N.V.</strong><br />
          Stokkelse Steenweg 304, 1200 Brussel, België<br />
          BTW: BE 0477.795.373<br />
          E-mail: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Verzamelde gegevens",
        html: `In het kader van het gebruik van de site en haar diensten verzamelen wij de volgende persoonsgegevens:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Identificatiegegevens:</strong> achternaam, voornaam, e-mailadres</li>
            <li><strong>Contactgegevens:</strong> telefoonnummer (optioneel)</li>
            <li><strong>Reserveringsgegevens:</strong> gereserveerde ruimtes, data, uren, bedragen</li>
            <li><strong>Betaalgegevens:</strong> veilig verwerkt door Stripe (wij slaan geen bankgegevens op)</li>
            <li><strong>Verbindingsgegevens:</strong> IP-adres, browsertype, bezochte pagina's</li>
          </ul>`,
      },
      {
        heading: "3. Doeleinden van de verwerking",
        html: `De persoonsgegevens worden verzameld voor de volgende doeleinden:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Beheer van reserveringen en betalingen</li>
            <li>Verzending van toegangscodes en bevestigingen per e-mail</li>
            <li>Beheer van abonnementen</li>
            <li>Communicatie met betrekking tot de dienst (wijzigingen, annuleringen)</li>
            <li>Verbetering van de dienst en gebruiksstatistieken</li>
            <li>Naleving van wettelijke en boekhoudkundige verplichtingen</li>
          </ul>`,
      },
      {
        heading: "4. Rechtsgrondslag van de verwerking",
        html: `De verwerking van uw gegevens berust op:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>De uitvoering van het contract:</strong> de verwerking is noodzakelijk voor het beheer van uw reservering en uw account</li>
            <li><strong>De wettelijke verplichting:</strong> voor boekhoudkundige en fiscale verplichtingen</li>
            <li><strong>Het gerechtvaardigd belang:</strong> voor de verbetering van onze diensten</li>
            <li><strong>De toestemming:</strong> voor het versturen van commerciële communicatie (indien van toepassing)</li>
          </ul>`,
      },
      {
        heading: "5. Bewaartermijn",
        html: `De persoonsgegevens worden bewaard gedurende de tijd die nodig is voor de doeleinden waarvoor zij werden verzameld:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Accountgegevens:</strong> gedurende de inschrijvingsperiode, vervolgens 3 jaar na de laatste activiteit</li>
            <li><strong>Reserveringsgegevens:</strong> 10 jaar (Belgische boekhoudkundige verplichtingen)</li>
            <li><strong>Verbindingsgegevens:</strong> 1 jaar</li>
          </ul>`,
      },
      {
        heading: "6. Ontvangers van de gegevens",
        html: `Uw persoonsgegevens kunnen worden doorgegeven aan de volgende ontvangers:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Stripe:</strong> voor de veilige verwerking van betalingen</li>
            <li><strong>Resend:</strong> voor het versturen van transactionele e-mails (bevestigingen, toegangscodes)</li>
            <li><strong>Combell:</strong> hostingprovider van de site</li>
          </ul>
          <p class="mt-2">Deze onderaannemers zijn gebonden door contractuele verplichtingen tot vertrouwelijkheid en beveiliging overeenkomstig de AVG.</p>`,
      },
      {
        heading: "7. Doorgifte buiten de EU",
        html: `Sommige van onze onderaannemers (Stripe) kunnen gegevens verwerken buiten de Europese Economische Ruimte. In dat geval worden passende waarborgen toegepast (modelcontractbepalingen van de Europese Commissie).`,
      },
      {
        heading: "8. Cookies",
        html: `De site gebruikt cookies voor de goede werking ervan en, met uw toestemming, voor bezoekersstatistieken.
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Strikt noodzakelijke cookies:</strong> sessie, taalvoorkeuren, beveiliging (geen toestemming vereist)</li>
            <li><strong>Statistische cookies:</strong> alleen als u hiermee akkoord gaat via onze banner</li>
          </ul>
          <p class="mt-2">U kunt uw voorkeuren op elk moment wijzigen via de link <strong>"Mijn cookies beheren"</strong> onderaan de pagina. Onze toestemmingsbanner wordt aangedreven door <strong>Tarteaucitron.js</strong>, een open source AVG-oplossing (<a href="https://tarteaucitron.io" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">tarteaucitron.io</a>), compatibel met Google Consent Mode v2.</p>`,
      },
      {
        heading: "9. Uw rechten",
        html: `Overeenkomstig de Algemene Verordening Gegevensbescherming (AVG) en de Belgische wetgeving beschikt u over de volgende rechten:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Recht op toegang:</strong> bevestiging krijgen dat gegevens over u worden verwerkt en een kopie ervan verkrijgen</li>
            <li><strong>Recht op rectificatie:</strong> onjuiste of onvolledige gegevens laten corrigeren</li>
            <li><strong>Recht op gegevenswissing:</strong> de verwijdering van uw gegevens vragen onder de voorwaarden van de AVG</li>
            <li><strong>Recht op beperking:</strong> de beperking van de verwerking van uw gegevens vragen</li>
            <li><strong>Recht op overdraagbaarheid:</strong> uw gegevens ontvangen in een gestructureerd en gangbaar formaat</li>
            <li><strong>Recht van bezwaar:</strong> zich verzetten tegen de verwerking van uw gegevens om legitieme redenen</li>
          </ul>
          <p class="mt-3">Om deze rechten uit te oefenen, neem contact met ons op via: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a></p>
          <p class="mt-2">Wij verbinden ons ertoe binnen een termijn van één maand na ontvangst van uw verzoek te antwoorden.</p>`,
      },
      {
        heading: "10. Toezichthoudende autoriteit",
        html: `Indien u van mening bent dat de verwerking van uw persoonsgegevens een inbreuk vormt op de AVG, heeft u het recht een klacht in te dienen bij de Gegevensbeschermingsautoriteit (GBA):
          <p class="mt-2"><strong>Gegevensbeschermingsautoriteit</strong><br />
          Drukpersstraat 35 - 1000 Brussel<br />
          <a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.gegevensbeschermingsautoriteit.be</a></p>`,
      },
      {
        heading: "11. Wijziging van het beleid",
        html: `D.P.F. Partners N.V. behoudt zich het recht voor om dit privacybeleid te allen tijde te wijzigen. Wijzigingen worden van kracht zodra zij op de site zijn gepubliceerd. Wij nodigen u uit deze pagina regelmatig te raadplegen.
          <p class="mt-2 text-[#737373]">Laatst bijgewerkt: Februari 2026</p>`,
      },
    ],
  },
  en: {
    title: "Privacy policy and GDPR",
    sections: [
      {
        heading: "1. Data controller",
        html: `The data controller of the personal data collected via the flexi-location.be website is:<br /><br />
          <strong>D.P.F. Partners S.A.</strong><br />
          304, Chaussée de Stockel, 1200 Brussels, Belgium<br />
          VAT: BE 0477.795.373<br />
          Email: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline">info@flexi-location.be</a>`,
      },
      {
        heading: "2. Data collected",
        html: `In the context of using the site and its services, we may collect the following personal data:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Identification data:</strong> last name, first name, email address</li>
            <li><strong>Contact data:</strong> telephone number (optional)</li>
            <li><strong>Booking data:</strong> reserved spaces, dates, times, amounts</li>
            <li><strong>Payment data:</strong> processed securely by Stripe (we do not store your bank details)</li>
            <li><strong>Connection data:</strong> IP address, browser type, pages visited</li>
          </ul>`,
      },
      {
        heading: "3. Purposes of processing",
        html: `Personal data is collected for the following purposes:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li>Management of bookings and payments</li>
            <li>Sending access codes and confirmations by email</li>
            <li>Management of subscriptions</li>
            <li>Service-related communication (changes, cancellations)</li>
            <li>Service improvement and usage statistics</li>
            <li>Compliance with legal and accounting obligations</li>
          </ul>`,
      },
      {
        heading: "4. Legal basis for processing",
        html: `The processing of your data is based on:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Contract performance:</strong> processing is necessary for the management of your booking and account</li>
            <li><strong>Legal obligation:</strong> for accounting and tax obligations</li>
            <li><strong>Legitimate interest:</strong> for the improvement of our services</li>
            <li><strong>Consent:</strong> for sending commercial communications (where applicable)</li>
          </ul>`,
      },
      {
        heading: "5. Retention period",
        html: `Personal data is kept for the period necessary for the purposes for which it was collected:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Account data:</strong> during the registration period, then 3 years after the last activity</li>
            <li><strong>Booking data:</strong> 10 years (Belgian accounting obligations)</li>
            <li><strong>Connection data:</strong> 1 year</li>
          </ul>`,
      },
      {
        heading: "6. Recipients of the data",
        html: `Your personal data may be transmitted to the following recipients:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Stripe:</strong> for the secure processing of payments</li>
            <li><strong>Resend:</strong> for sending transactional emails (confirmations, access codes)</li>
            <li><strong>Combell:</strong> site hosting provider</li>
          </ul>
          <p class="mt-2">These subcontractors are bound by contractual confidentiality and security obligations in accordance with the GDPR.</p>`,
      },
      {
        heading: "7. Transfer outside the EU",
        html: `Some of our subcontractors (Stripe) may process data outside the European Economic Area. In this case, appropriate safeguards are put in place (standard contractual clauses of the European Commission).`,
      },
      {
        heading: "8. Cookies",
        html: `The site uses cookies to ensure its proper functioning and, with your consent, to measure audience.
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Strictly necessary cookies:</strong> session, language preferences, security (no consent required)</li>
            <li><strong>Analytics cookies:</strong> only with your explicit consent via our banner</li>
          </ul>
          <p class="mt-2">You can change your preferences at any time via the <strong>"Manage my cookies"</strong> link at the bottom of the page. Our consent banner is powered by <strong>Tarteaucitron.js</strong>, an open source GDPR solution (<a href="https://tarteaucitron.io" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">tarteaucitron.io</a>), compatible with Google Consent Mode v2.</p>`,
      },
      {
        heading: "9. Your rights",
        html: `In accordance with the General Data Protection Regulation (GDPR) and Belgian law, you have the following rights:
          <ul class="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Right of access:</strong> obtain confirmation that data concerning you is being processed and obtain a copy thereof</li>
            <li><strong>Right to rectification:</strong> have inaccurate or incomplete data corrected</li>
            <li><strong>Right to erasure:</strong> request the deletion of your data under the conditions provided for by the GDPR</li>
            <li><strong>Right to restriction:</strong> request the restriction of the processing of your data</li>
            <li><strong>Right to portability:</strong> receive your data in a structured and commonly used format</li>
            <li><strong>Right to object:</strong> object to the processing of your data on legitimate grounds</li>
          </ul>
          <p class="mt-3">To exercise these rights, contact us at: <a href="mailto:info@flexi-location.be" class="text-[#C77D63] hover:underline ml-1">info@flexi-location.be</a></p>
          <p class="mt-2">We undertake to respond within one month of receiving your request.</p>`,
      },
      {
        heading: "10. Supervisory authority",
        html: `If you consider that the processing of your personal data constitutes a breach of the GDPR, you have the right to lodge a complaint with the Data Protection Authority (DPA):
          <p class="mt-2"><strong>Data Protection Authority</strong><br />
          Rue de la Presse, 35 - 1000 Brussels<br />
          <a href="https://www.dataprotectionauthority.be" target="_blank" rel="noopener noreferrer" class="text-[#C77D63] hover:underline">www.dataprotectionauthority.be</a></p>`,
      },
      {
        heading: "11. Policy changes",
        html: `D.P.F. Partners S.A. reserves the right to modify this privacy policy at any time. Changes take effect as soon as they are published on the site. We invite you to consult this page regularly.
          <p class="mt-2 text-[#737373]">Last updated: February 2026</p>`,
      },
    ],
  },
};

/** Resolve the current locale to one of our supported keys ('fr' | 'nl' | 'en'). */
export function resolveLegalLocale(lang) {
  const l = (lang || "fr").slice(0, 2).toLowerCase();
  return l === "nl" || l === "en" ? l : "fr";
}
